import { render } from "./ImageLoading.vue?vue&type=template&id=9a4d2670&scoped=true"
const script = {}

import "./ImageLoading.vue?vue&type=style&index=0&id=9a4d2670&scoped=true&lang=css"

import exportComponent from "/home/runner/work/uup/uup/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-9a4d2670"]])

export default __exports__